var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading_box"},[_c('div',{staticClass:"loading_mask"}),_c('div',{staticClass:"loading_toast"},[_c('spinner',{attrs:{"type":"android"}}),_c('p',{staticClass:"loading_content"},[_vm._v(_vm._s(_vm.text || "加载中"))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }